export const comparisonResponseStatus = {
  NONE: 0,
  SUCCESS: 1,
  VERIFY: 2
};
